import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.AddressSuggestionModal .BaseModal-Body {
    padding: ${spacing(10)};
    max-width: 480px;
    margin: 0 auto;
  }

  .modal-title {
    ${fontH3}
    color: ${text_colorTextPrimary};
    margin-bottom: ${spacing(5)};
  }

  .suggestion-radio-group {
    margin-bottom: ${spacing(5)};

    .RadioGroup--buttons label.RadioButton {
      cursor: pointer;

      .RadioButton--title {
        font-family: ${font_family_weight_regular};
        white-space: pre-line;
      }
    }
  }

  .button-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`
